import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import useSortedContests from "../contests/hooks/useSortedContests";
import { useAuth } from "../../context/AuthContext";

const RunningContests = () => {
  const { contests } = useOutletContext();
  const { userId } = useAuth();
  const { sortedContests, requestSort, sortConfig } = useSortedContests(
    contests || [], // Use contests from context
    "deadline",
    "descending"
  );
  const navigate = useNavigate();

  const handleContestClick = (contestId) => {
    navigate(`/contests/running/${contestId}`);
  };

  const getSortIndicator = (key) => {
    if (!sortConfig || sortConfig.key !== key) return "";
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };

  // Add check for empty contests array (after loading)
  if (!contests || contests.length === 0) {
    return (
      <div className="contests-table-container">
        <p>No running contests found.</p>
      </div>
    );
  }

  return (
    <div className="open-contests-container">
      <div className="contests-table-container">
        <table className="contests-table">
          <thead>
            <tr>
              {[
                { label: "Name", key: "tournamentName" },
                { label: "Fee", key: "entryFee" },
                { label: "Format", key: "format" },
                { label: "Entries", key: "entrantsCount" },
              ].map(({ label, key }) => (
                <th key={key} onClick={() => requestSort(key)}>
                  {label} {getSortIndicator(key)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedContests.map((contest, index) => {
              const isUserEntered =
                userId &&
                contest.entrants?.some((entrant) => entrant.userId === userId);

              return (
                <tr
                  key={contest._id || index}
                  className="contest-row"
                  onClick={() => handleContestClick(contest._id)}
                >
                  <td data-label="Name">
                    {isUserEntered && (
                      <span title="You have an entry in this contest">⭐ </span>
                    )}
                    {contest.tournamentName}
                  </td>
                  <td data-label="Fee">
                    ${(contest.entryFee || 0) + (contest.adminFee || 0)}
                  </td>
                  <td data-label="Format">{contest.format}</td>
                  <td data-label="Entrants">{contest.entrantsCount || 0}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RunningContests;
